var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.$apollo.queries.queriedPerson.loading)?_c('span',[_c('v-progress-circular',{attrs:{"active":"","indeterminate":"","size":"16","color":"muted"}})],1):(!_vm.person)?_c('span',[_vm._v(" - ")]):(_vm.noLink)?_c('span',[_vm._v("\n    "+_vm._s(_vm.displayName)+"\n  ")]):_c('router-link',{staticClass:"no-default-link-style",attrs:{"to":{
      name: 'PersonProfilePage',
      params: { personId: _vm.displayPerson.id }
    },"target":_vm.linkTarget}},[_vm._v(_vm._s(_vm.displayName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }